<div class="row">
    <div class="col-md-12" *ngIf="requestType === 'UPDATE_VIRUS_DB' && lastUpdatedOn">
        <p class="mb-0 publishTxt">{{"LASTUPDATED.VIRUSUPDATE" | translate}} {{lastUpdatedOn}}</p>
    </div>
    <div class="col-md-12" *ngIf="requestType === 'SCORE' && lastUpdatedOn">
        <p class="mb-0 publishTxt">{{"LASTUPDATED.SCOREUPDATE" | translate}} {{lastUpdatedOn}}</p>
    </div>

    <div *ngIf="requestType === 'GET_SECURITY_SETTINGS' && lastUpdatedOn">
        <p class="mb-0 publishTxt">{{"LASTUPDATED.PUBLISHEDON" | translate}} {{lastUpdatedOn}}</p>
    </div>
    <div *ngIf="requestType === 'UPDATE_ALL_DETAILS' && lastUpdatedOn">
        <p class="mb-0 publishTxt">{{"LASTUPDATED.LASTUPDATE" | translate}} {{lastUpdatedOn}}</p>
    </div>
    <div *ngIf="requestType === 'SCAN_FROM_CLOUD' && lastUpdatedOn">
        <p class="mb-0 publishTxt">{{"LASTUPDATED.LASTUPDATE" | translate}} {{lastUpdatedOn}}</p>
    </div>
</div>